<template>
<div class="root" ref="login">
  <div class="top-bg"></div>
  <div class="login-form" ref="">
    <img src="../assets/images/login_03.png" class="img">
    <div class="form">
      <template v-if="loginType!='mobile'">
      <input v-model="loginForm.username" placeholder="请输入登录账号">
      <input v-model="loginForm.password" type="password" placeholder="请输入登录密码">
      <div class="login-btn" @click="handleSubmit">登录</div>
        <div class="login-type"><span @click="loginType='mobile'">使用手机号登录</span></div>
      </template>
      <template v-else>
        <template v-if="!accountList ||accountList.length == 0">
        <input v-model="loginForm.mobile" placeholder="请输入绑定的手机号码">
        <div style="position: relative;">
          <input v-model="loginForm.code" type="number" placeholder="请输入4位验证码">
          <span class="send-bnt">
            <span @click="sendCode" v-if="sendInt == 0" style="color: #0b8ed4;cursor: pointer;line-height:40px;">{{codetext}}</span>
            <span v-else style="line-height:40px;color:#8f8a8a">{{sendInt}} 秒</span>
          </span>
        </div>
        <div class="login-btn" @click="submitFormMobile">登录</div>
        </template>
        <template v-else>
          <div class="account-list">
            <div class="title">请点击需要登录的账号，进行登录</div>
            <div class="account-list-item" @click="loginByMobileAccount(name)" v-for="(name,index) in accountList">{{name}}</div>
          </div>
        </template>

        <div class="login-type" ><span @click="loginType=''">使用账号密码登录</span></div>
      </template>
    </div>
  </div>
</div>
</template>
<script>

    export default {
        name: "login",
        data() {
            return {
              sendInt:0,
              accountList:[],
              codetext:'获取验证码',
              loginType:'',
                loginForm:{
                    username:'',
                    password:'',
                  loading:false
                },
            };
        },
        watch:{
            loginType(){
                this.accountlist = [];
            }
        },
        methods: {
            submitFormMobile(){
                if(!this.loginForm.mobile){
                    return this.$toast("请输入手机号码");
                }
                if(!this.loginForm.code){
                    return this.$toast("请输入验证码");
                }
                this.fetchData('/login/getAccountLlist',this.loginForm,res=>{
                    if(res.code){
                        this.accountList = res.data
                    }else{
                        this.$toast(res.msg)
                    }
                })
            },
            loginByMobileAccount(name){
                this.loginForm.username = name
                this.fetchData('/login/loginByMobileAccount',this.loginForm,response=>{
                    if(response.code){
                        sessionStorage.setItem('agenttoken', response.data.token);
                        sessionStorage.setItem('userInfo', JSON.stringify(response.data.userInfo))
                        this.$router.push({name:'index'})
                    }else{
                        this.accountList = [];
                        this.$toast(response.msg)
                    }
                })
            },
            handleSubmit(){
              if(this.loading) return  false;
              this.loading = true
                if(!this.loginForm.username){
                    this.$toast.fail('请输入账号');
                    return false;
                }
                if(!this.loginForm.password){
                    this.$toast.fail('请输入密码');
                    return false;
                }
                this.$toast.loading("登录中")
                this.fetchDataPost('/login/login',this.loginForm,(res)=>{
                  this.loading = false
                    if(res.code){
                      this.$toast.clear()
                        sessionStorage.setItem('agenttoken', res.data.token);
                        sessionStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
                        this.$router.push({name:'index'})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
          sendCode(){
            if(!this.loginForm.mobile){
              return this.$toast("请输入手机号码");
            }
            this.fetchData('/verify/sendCode',this.loginForm,res=>{
              if(res.code){
                this.sendInt = 60
                let int = setInterval(()=>{
                  this.sendInt--
                  if(this.sendInt<1){
                    clearInterval(int)
                  }
                },1000)
              }else{
                this.$toast(res.msg)
              }
            })
          },
        },
        mounted(){
            const windowHeight = window.innerHeight;
            this.$refs.login.style.height = windowHeight+'px';
        },
        created() {

        },
    };
</script>
<style lang="scss" scoped>
.root{
  font-size: 0;
  .account-list{
    font-size: .24rem;
    .title{
      color: #71a1fd;
      font-size: 16px;
      text-align: left;
      margin-bottom: 16px;
    }
    .account-list-item{
      margin-top: 10px;
      height: 40px;
      width: 100%;
      line-height: 40px;
      color: #0051fe;
      background: #fff;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      &:hover{
        color: #1e9661;
      }
    }
  }
  .login-type{
    font-size: .24rem;
    text-align: center;
    margin-top: .4rem;
    color: #0051fe;
  }
  .send-bnt{
    font-size: .24rem;
    position: absolute;
    right: .2rem;
    top: 0;
  }
  .top-bg{
    width: 100%;
    height: .5rem;
    background-image: linear-gradient(to right, #daf4f8 ,#c4dcfc, #d0e0ff);
  }
  .login-form{
    background-image: linear-gradient(to right, #ecfafc ,#e2eefe, #ecf2ff);
    height: calc( 100% - .2rem);
    width: 100%;
    border-top-left-radius: .3rem;
    border-top-right-radius: .3rem;
    margin-top: -.3rem;
    .img{
      width: 1.59rem;
      height: 1.59rem;
      display: block;
      padding-top: .9rem;
      margin: 0 auto .9rem;
    }
    .form{
        width: 6.9rem;
        margin: 0 auto;
      input{
        width: 100%;
        border: none;
        height: .8rem;
        background: #fbfdff;
        border-radius: .3rem;
        line-height: .8rem;
        font-size: .28rem;
        text-indent: .3rem;
        color: #666;
        margin-bottom: .4rem;
      }
      .login-btn{
        width: 100%;
        height: .8rem;
        margin-top: 1rem;
        line-height: .8rem;
        text-align: center;
        color: #ffff;
        font-size: .3rem;
        background: #0051fe;
        border-radius: .3rem;
      }
    }
  }
}
input::-webkit-input-placeholder {
  color:#cdd3e0;
  font-size: 0.26rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue